module.exports = __webpack_public_path__ + "img/Message Push.088d3a81.svg";